import { CmpTemplates } from "../../../components/template/CmpTemplates";
import {
  GET_USER_DRIVER_QUALIFICATION_IMAGE,
  POST_USER_DRIVER_QUALIFICATION_IMAGE,
} from "../../../common/query-keys";
import { useRef, useState } from "react";
import { request, tryCatchError } from "../../../lib/api";
import { useMutation } from "@tanstack/react-query";
import { CmpCarRegistInfoContent } from "../../../components/organisms/CmpPageContent/CmpCarRegistInfoContent";
import { useRecoilState } from "recoil";
import { userSignState } from "../../../states/user-sign-up";
import imageCompression from "browser-image-compression";
import { useNavigate } from "react-router";
const CmpCarRegistInfoPage = (props: any) => {
  const navigate = useNavigate();
  const imgRef = useRef<any>();
  const cameraRef = useRef<any>();
  const [imgFile, setImgFile] = useState<any>([]);
  const [userSignUpData, setUserSignUpData] = useRecoilState(userSignState);

  // 이미지 업로드 버튼 클릭시 실행 함수
  const { mutateAsync: ImgUpload } = useMutation({
    mutationFn: (formData: FormData) => {
      return request({
        method: "POST",
        url: POST_USER_DRIVER_QUALIFICATION_IMAGE,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onError: () => {
      alert("이미지 업로드에 실패했습니다.");
    },
  });

  // 이미지 업로드시 이미지 변경 함수
  const onChangeImg = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!e.target.files) return;
    try {
      const imgFile = e.target.files[0];
      const formData = new FormData();

      // 이미지 압축 옵션
      const options = {
        maxSizeMB: 0.4,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };

      const fileExtension = imgFile.name.split(".").pop();
      const compressedFile = await imageCompression(imgFile, options);

      // 압축된 파일에 확장자 추가
      const compressedFileWithExt = new File(
        [compressedFile],
        `${compressedFile.name}.${fileExtension}`,
        { type: compressedFile.type }
      );

      formData.append("image", compressedFileWithExt);
      const result: any = await ImgUpload(formData);
      setImgFile(result);
    } catch (error) {
      tryCatchError(error);
    }
  };
  // 이미지 업로드 버튼
  const handleClick = () => {
    imgRef.current.click();
  };

  // 다음 버튼
  const onSave = () => {
    if (imgFile.length !== 0) {
      if (userSignUpData.carRegistration) {
        setUserSignUpData((prev: any) => ({
          ...prev,
          carRegistration: {
            ...prev.carRegistration,
            imagename: imgFile[0].originalname,
            size: imgFile[0].size,
            imageUrl: `${GET_USER_DRIVER_QUALIFICATION_IMAGE}${imgFile[0].filename}`,
          },
        }));
      } else {
        setUserSignUpData((prev: any) => ({
          ...prev,
          carRegistration: {
            imagename: imgFile[0].originalname,
            size: imgFile[0].size,
            imageUrl: `${GET_USER_DRIVER_QUALIFICATION_IMAGE}${imgFile[0].filename}`,
            qualificationType: "CAR_REGISTRATION",
          },
        }));
      }
    }

    navigate("/cmp-sign");
  };

  // 이전 버튼
  const onBackHanlder = () => {
    navigate(-1);
  };

  return (
    <CmpTemplates pageTitle="회원가입">
      <CmpCarRegistInfoContent
        imgRef={imgRef}
        cameraRef={cameraRef}
        imgFile={
          imgFile.length !== 0
            ? imgFile
            : userSignUpData.carRegistration
            ? [userSignUpData.carRegistration]
            : []
        }
        handleClick={handleClick}
        onBackHanlder={onBackHanlder}
        onChangeImg={onChangeImg}
        onSave={onSave}
      />
    </CmpTemplates>
  );
};

export default CmpCarRegistInfoPage;
